import { Fragment, useEffect, useState } from 'react';
import usePortal from 'react-cool-portal';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { ReactComponent as ReportIcon } from '../assets/images/reportCheck.svg';

const ButtonIconDropdown = ({
  items,
  onClick,
  disabled,
  Icon,
  hw,
  iconH,
  iconW,
  extraClass,
  tooltipId,
  disabledInnerIcons,
  dropDownPosition,
  name
}) => {
  const [position, setPosition] = useState();

  const { Portal, show } = usePortal({
    defaultShow: false,
    onShow: e => {
      e.persist();
      const bodyRect = document.body.getBoundingClientRect();
      const elemRect = e.currentTarget.getBoundingClientRect();
      const clientRects = e.currentTarget.getClientRects();
      const offset = elemRect.top - bodyRect.top;
      const { left: leftVal, right } = elemRect;
      if (dropDownPosition) {
        setPosition(dropDownPosition(elemRect, bodyRect, clientRects));
      } else {
        setPosition({ top: `${offset + 38}px`, right: `calc(${right}px - ${leftVal}px + 40px)` });
      }
    }
  });

  const click = item => {
    if (item.disabled) return;
    onClick(item.id, item.extention, items);
  };

  useEffect(() => {
    if (tooltipId) {
      ReactTooltip.rebuild();
    }
  });

  return (
    <div
      className={`${extraClass} export-download-dropdown  review-download-dropdown buttonIconDropdown mr-1`}
    >
      <button
        type="button"
        onClick={show}
        className={`navbar-nav-link d-flex align-items-center reportBtn hw${hw}`}
        disabled={disabled}
      >
        {!name ? <Icon height={iconH || 18} width={iconW || 18} className="d-inline-flex" fill="#616674" /> :
          <div className="btn-lebal" >
            <Icon height={iconH || 18} width={iconW || 18} className="d-inline-flex" fill="#616674" />
            <span className="ml-1">{name}</span>
          </div>
        }
      </button>
      <Portal>
        <div
          className={`${extraClass}-menu dropdown-menu dropdown-menu-right show atg-dropdown-menu`}
          style={position}
        >
          {items.map(b => (
            <Fragment key={b.id}>
              {b?.customCommponent ? <div className="item-wrapper">{b.customCommponent}  </div> :
                <button
                  key={b.id}
                  type="button"
                  className={`dropdown-item ${b.disabled && 'disabled-item'}`}
                  data-for={tooltipId}
                  data-tip={b.tooltip}
                  data-html
                  data-tip-disable={b.tooltipDisable}
                  onClick={() => click(b)}
                >
                  <div className="item-wrapper">
                    {b.Icon ? (
                      <b.Icon />
                    ) : (
                      <ReportIcon
                        height={18}
                        width={18}
                        className={`mr-1 ${disabledInnerIcons ? 'd-none' : 'd-inline-flex'}`}
                        fill="#616674"
                      />
                    )}
                    <span>{b.filename || b.name}</span>
                  </div>
                </button>
              }
              {tooltipId && (
                <ReactTooltip id={tooltipId} place="bottom" className="protean-tooltip" />
              )}
            </Fragment>
          ))}
        </div>
      </Portal>
    </div>
  );
};

ButtonIconDropdown.propTypes = {
  items: PropTypes.instanceOf(Array),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  Icon: PropTypes.instanceOf(Object),
  hw: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconH: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconW: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  extraClass: PropTypes.string,
  tooltipId: PropTypes.string,
  disabledInnerIcons: PropTypes.bool,
  dropDownPosition: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(Object)])
};

ButtonIconDropdown.defaultProps = {
  items: [],
  onClick: () => {},
  disabled: false,
  Icon: () => <ReportIcon />,
  hw: '',
  iconH: 18,
  iconW: 18,
  extraClass: '',
  tooltipId: '',
  disabledInnerIcons: false,
  dropDownPosition: null,
  name : null
};

export default ButtonIconDropdown;
